/* Game Night: game-sheet modal + per-game tools.
   Ported from Game Night.dc.html (2026-08-10 handoff). State is per-page,
   nothing persists. Copy in GAMES is final; do not rewrite. */
(function () {
  var modal = document.querySelector('[data-mpn-modal]');
  if (!modal) return;

  var GAMES = {
    wig: {
      title: 'W.I.G.', accent: '#FF3D8A', tagline: 'P.I.G. grew up and got a job to go to tomorrow.',
      chips: ['2+ PLAYERS', 'ANY SPORT', 'STAKES: YOUR TUESDAY'],
      setup: ['Pick any game with a shot in it: hoops, darts, cornhole, beer pong, bar dice.', 'Line up the order. Loser of a coin flip shoots first. That’s tradition now.', 'Put one mullet where everyone can see it. That’s the pot.'],
      play: ['Make your shot and the next player has to match it. They miss, they take a letter. W, then I, then G.', 'Trick shots are legal, encouraged, and historically where empires fall.'],
      stakes: 'Three letters and you wear a mullet to work the next day. Or school. Or brunch with the in-laws. Photo proof in the group chat by 10 AM. No hats, no hoods, no mercy.',
      pro: 'Never call an easy shot when the person after you signs your paychecks.',
      needs: '1 mullet minimum'
    },
    baggrab: {
      title: 'Bag Grab', accent: '#FF3D8A', tagline: 'The ritual, scored.',
      chips: ['4+ PLAYERS', 'ALL NIGHT', 'STAKES: YOUR IDENTITY'],
      setup: ['One bag, at least one mullet per head, held shut until the moment.', 'Everybody in a circle. Someone films. You’ll want this later.'],
      play: ['Pull blind. One hand, no peeking, no trades. Whoever you pull is who you are now.', 'Answer to the name. Defend the backstory. Introduce yourself to strangers accordingly.'],
      stakes: 'First to break character refills every drink in the room. Repeat offenders plan the next party.',
      pro: 'The quiet friend always pulls the loudest mullet. We don’t schedule this. It just happens.',
      needs: 'one mullet per head'
    },
    olympics: {
      title: 'Mullet Olympics', accent: '#7B5CFF', tagline: 'Five events. One champion. Zero dignity.',
      chips: ['6+ PLAYERS', '1 HOUR', 'STAKES: THE RECORD'],
      setup: ['Pick five events: musical chairs, limbo, a three-legged sprint, flip cup, and one freestyle the host invents on the spot.', 'Split into teams or go solo. Wigs on before the anthem.'],
      play: ['Score each event 3, 2, 1. Wigs stay on through everything. That is the sport.', 'The freestyle event is worth double. The host’s word is final and openly corrupt.'],
      stakes: 'Gold medalist keeps their mullet forever. It’s on the record. Last place organizes the rematch.',
      pro: 'Limbo in a mullet is a different game. The hair goes first.',
      needs: '6+ mullets'
    },
    business: {
      title: 'Business in Front', accent: '#2B6BFF', tagline: 'Deliver the quarterly numbers. In the wig.',
      chips: ['3+ PLAYERS', '20 MINUTES', 'STAKES: THE FLOOR'],
      setup: ['Everyone preps a thirty-second toast: corporate-serious, full sincerity. Quarterly numbers. A heartfelt thanks to the team.', 'Mullets on. Ties optional but devastating.'],
      play: ['One at a time, deliver your toast to the room like the board is watching.', 'The room votes at the end. Laugh mid-toast and you’re disqualified. Best deadpan wins.'],
      stakes: 'Winner closes the night with a real toast. Losers clap. That’s the punishment, somehow.',
      pro: 'The phrase “moving forward” gets a standing ovation every time. Nobody knows why.',
      needs: '3+ mullets and a straight face'
    },
    secret: {
      title: 'Secret Mullet', accent: '#0E8A5F', tagline: 'Assassin, but make it hair.',
      chips: ['5+ PLAYERS', 'WHOLE PARTY', 'STAKES: ELIMINATION'],
      setup: ['Write every name on a slip. Everyone draws a target in secret.', 'Wigs on at the door. That’s the whole loadout.'],
      play: ['Catch your target without their wig on and they’re out. You inherit their target.', 'Wigs come off for nothing: not dinner, not photos, not the pool. Especially not the pool.'],
      stakes: 'Last head standing wins. The winner’s mullet retires undefeated.',
      pro: 'The bathroom is where careers end. Plan accordingly.',
      needs: 'one per player, no spares'
    },
    freeze: {
      title: 'Freeze', accent: '#D6216B', tagline: 'The aux cord is loaded now.',
      chips: ['ANY SIZE', 'SONG BY SONG', 'STAKES: THE NEXT ROUND'],
      setup: ['One person controls the music. They are God now. Address them accordingly.', 'Everyone else on the floor, wigs on.'],
      play: ['Music plays, mullets dance. Music stops, mullets freeze.', 'Last one moving takes the loss. God’s ruling is final and can be bribed.'],
      stakes: 'Loser buys the next round, or takes a W.I.G. letter, or whatever your room decides losing costs tonight.',
      pro: 'Commit to the freeze. Judges respect a held pose more than a good dance.',
      needs: 'mullets and a speaker'
    },
    documentary: {
      title: 'The Documentary', accent: '#5B3FE8', tagline: 'A scavenger hunt for the group chat.',
      chips: ['2+ PLAYERS', 'FIRST TO FIVE', 'STAKES: THE COVER PHOTO'],
      setup: ['Everyone gets the shot list. Cameras out, mullets on.', 'Set the window: one party, one weekend, one wedding reception.'],
      play: ['The shot list: a stranger wearing one of your mullets. A mullet in a family portrait. A mullet ordering food dead serious. The whole crew in one frame. And one shot so good it becomes somebody’s profile picture.', 'First to five wins. Judges may reject any photo that lacks conviction.'],
      stakes: 'Winner picks the group chat’s cover photo. That’s real power and you know it.',
      pro: 'Grandmas say yes more often than you’d think. 31 documented.',
      needs: 'mullets and one full battery'
    },
    hairdrop: {
      title: 'The Hairdrop', accent: '#2B6BFF', tagline: 'The catch is you catch it with your head.',
      chips: ['4+ PLAYERS', '15 MINUTES', 'STAKES: BACKWARDS'],
      setup: ['Pair up. One mullet per pair, thrower holds it. Everyone else clears the airspace.', 'Two lines facing each other, one easy step apart. That part doesn’t last.'],
      play: ['Toss the wig and your partner catches it on their head. No hands. Hands are for people playing an easier game.', 'Clean catch and both lines take one step back. Miss it, drop it, or steady it with a hand and your pair is out.'],
      stakes: 'Last pair standing wins the room. Every eliminated pair wears their wigs backwards for the rest of the night, so the whole party can see exactly what a dropped catch costs.',
      pro: 'Aim for the forehead and let physics finish the job. The wig wants to be on a head. Trust the wig.',
      needs: 'one mullet per pair and some airspace'
    },
    musicalhairs: {
      title: 'Musical Hairs', accent: '#0E8A5F', tagline: 'Your wig is not your wig.',
      chips: ['5+ PLAYERS', 'UNTIL TWO REMAIN', 'STAKES: THE DUEL'],
      setup: ['Count heads, subtract one. That’s the wig count. Coin flip picks the bare head who starts hungry.', 'One person on the aux. Yes, the same God who runs Freeze. Both kingdoms, one throne.'],
      play: ['Music plays, everybody dances. Music stops, every wig changes heads. You can’t keep yours and you can’t guard it: hands off your own head, go rob somebody else’s.', 'A wig on a head is up for grabs. A wig in a hand is claimed. That’s the whole safety briefing. When the dust settles, the bare head is out and takes one wig with them.', 'The knocked-out don’t leave. They join the booth and vote on when the music stops. The committee grows every round. So do the grudges.'],
      stakes: 'It ends with two players circling one wig while the room films. The winner’s mullet becomes the Champion’s Mullet, worn the rest of the night, non-negotiable. First one out takes a W.I.G. letter.',
      pro: 'Office crowd or little kids? Call Wigs Up: music stops, every wig goes straight in the air, everyone comes down wearing a different one. Same chaos, zero robbery.',
      needs: 'one mullet per head, minus exactly one'
    }
  };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function q(sel) { return modal.querySelector(sel); }

  /* ---- modal open/close ---- */
  var sheet = q('[data-mpn-sheet]');
  var active = null;

  function open(id) {
    var g = GAMES[id];
    if (!g) return;
    active = id;
    sheet.style.setProperty('--mpn-accent', g.accent);
    q('[data-mpn-title]').textContent = g.title;
    q('[data-mpn-title]').style.color = g.accent;
    q('[data-mpn-tagline]').textContent = g.tagline;
    q('[data-mpn-chips]').innerHTML = g.chips.map(function (c) {
      return '<span class="mpn-sheet__chip">' + esc(c) + '</span>';
    }).join('');
    q('[data-mpn-setup]').innerHTML = g.setup.map(function (t, i) {
      return '<div class="mpn-setup__row"><span class="mpn-setup__n" style="color:' + g.accent + '">' + (i + 1) + '</span><span class="mpn-setup__t">' + esc(t) + '</span></div>';
    }).join('');
    q('[data-mpn-play]').innerHTML = g.play.map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('');
    modal.querySelectorAll('.mpn-sheet__k, .mpn-setup__n').forEach(function (n) { n.style.color = g.accent; });
    q('[data-mpn-stakes]').textContent = g.stakes;
    q('[data-mpn-pro]').textContent = g.pro;
    q('[data-mpn-needs]').textContent = g.needs;
    modal.querySelectorAll('[data-mpn-tool]').forEach(function (t) {
      t.hidden = t.getAttribute('data-mpn-tool') !== id;
    });
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    q('[data-mpn-close]').focus();
  }

  function close() {
    active = null;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-mpn-open]').forEach(function (el) {
    var id = el.getAttribute('data-mpn-open');
    el.addEventListener('click', function () { open(id); });
    if (el.getAttribute('role') === 'button') {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(id); }
      });
    }
  });
  modal.querySelectorAll('[data-mpn-close]').forEach(function (b) { b.addEventListener('click', close); });
  modal.addEventListener('click', function (e) { if (!sheet.contains(e.target)) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

  /* ---- helpers for add-a-name tools ---- */
  function wireAdd(inputSel, btnSel, fn) {
    var input = q(inputSel);
    q(btnSel).addEventListener('click', function () { fn(input.value.trim()); input.value = ''; });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { fn(input.value.trim()); input.value = ''; }
    });
  }
  var badge = function (text, bg, col) {
    return '<span class="mpn-tool__badge" style="background:' + bg + ';color:' + (col || '#fff') + '">' + text + '</span>';
  };

  /* ---- W.I.G. letter tracker ---- */
  var wig = [];
  function renderWig() {
    q('[data-mpn-wig-rows]').innerHTML = wig.map(function (p, i) {
      var slots = ['W', 'I', 'G'].map(function (ch, j) {
        var on = j < p.letters;
        return '<span class="mpn-wig__slot" style="background:' + (on ? '#FF3D8A' : '#fff') + ';color:' + (on ? '#fff' : 'rgba(23,16,43,0.35)') + '">' + ch + '</span>';
      }).join('');
      return '<div class="mpn-tool__row"><span class="mpn-tool__name">' + esc(p.name) + '</span>' +
        (p.letters >= 3 ? badge('WEARS IT TOMORROW', '#FF3D8A') : '') +
        '<div class="mpn-wig__slots">' + slots + '</div>' +
        (p.letters < 3 ? '<button type="button" class="mpn-tool__pillbtn" data-i="' + i + '" data-act="letter">They missed +</button>' : '') +
        '<button type="button" class="mpn-tool__x" data-i="' + i + '" data-act="remove" aria-label="Remove player">&times;</button></div>';
    }).join('');
  }
  wireAdd('[data-mpn-wig-name]', '[data-mpn-wig-add]', function (n) {
    if (n) { wig.push({ name: n, letters: 0 }); renderWig(); }
  });
  q('[data-mpn-wig-reset]').addEventListener('click', function () { wig = []; renderWig(); });
  q('[data-mpn-wig-rows]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var i = +b.getAttribute('data-i');
    if (b.getAttribute('data-act') === 'letter') wig[i].letters = Math.min(3, wig[i].letters + 1);
    else wig.splice(i, 1);
    renderWig();
  });

  /* ---- Bag Grab lineup ---- */
  var bag = [];
  function renderBag() {
    q('[data-mpn-bag-rows]').innerHTML = bag.map(function (p, i) {
      return '<div class="mpn-tool__row"><span style="font-family:var(--mpx-font-display);font-size:20px;color:#D6216B;min-width:28px">' + (i + 1) + '</span>' +
        '<span class="mpn-tool__name">' + esc(p.name) + '</span>' +
        (p.broke ? badge('REFILLS EVERY DRINK', '#FF3D8A') : '') +
        '<button type="button" class="mpn-tool__pillbtn" data-i="' + i + '">' + (p.broke ? 'Un-break' : 'Broke character') + '</button></div>';
    }).join('');
  }
  wireAdd('[data-mpn-bag-name]', '[data-mpn-bag-add]', function (n) {
    if (n) { bag.push({ name: n, broke: false }); renderBag(); }
  });
  q('[data-mpn-bag-shuffle]').addEventListener('click', function () {
    for (var i = bag.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = bag[i]; bag[i] = bag[j]; bag[j] = t;
    }
    renderBag();
  });
  q('[data-mpn-bag-reset]').addEventListener('click', function () { bag = []; renderBag(); });
  q('[data-mpn-bag-rows]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-i]');
    if (!b) return;
    var p = bag[+b.getAttribute('data-i')];
    p.broke = !p.broke;
    renderBag();
  });

  /* ---- Olympics podium ---- */
  var oly = [];
  function renderOly() {
    var max = 0;
    oly.forEach(function (t) { if (t.score > max) max = t.score; });
    var rows = oly.map(function (t, i) { return { t: t, i: i }; })
      .sort(function (a, b) { return b.t.score - a.t.score; });
    q('[data-mpn-oly-rows]').innerHTML = rows.map(function (r) {
      return '<div class="mpn-tool__row"><span class="mpn-tool__name">' + esc(r.t.name) + '</span>' +
        (r.t.score > 0 && r.t.score === max ? badge('GOLD, FOREVER', '#22E5A2', '#17102B') : '') +
        '<span class="mpn-oly__score">' + r.t.score + '</span>' +
        '<div class="mpn-oly__btns">' +
        [3, 2, 1].map(function (n) {
          return '<button type="button" class="mpn-tool__pillbtn" data-i="' + r.i + '" data-n="' + n + '">+' + n + '</button>';
        }).join('') + '</div></div>';
    }).join('');
  }
  wireAdd('[data-mpn-oly-name]', '[data-mpn-oly-add]', function (n) {
    if (n) { oly.push({ name: n, score: 0 }); renderOly(); }
  });
  q('[data-mpn-oly-reset]').addEventListener('click', function () { oly = []; renderOly(); });
  q('[data-mpn-oly-rows]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-n]');
    if (!b) return;
    oly[+b.getAttribute('data-i')].score += +b.getAttribute('data-n');
    renderOly();
  });

  /* ---- Business in Front: 30s toast timer + votes ---- */
  var toastLeft = 30;
  var toastTimer = null;
  var speakers = [];
  function renderToast() {
    var time = q('[data-mpn-toast-time]');
    time.textContent = toastLeft + 's';
    time.style.color = toastLeft === 0 ? '#D6216B' : '#1D4FC4';
    q('[data-mpn-toast-toggle]').textContent = toastTimer ? 'Pause' : 'Start the toast';
    q('[data-mpn-toast-over]').hidden = toastLeft !== 0;
  }
  function renderSpeakers() {
    var max = 0;
    speakers.forEach(function (s) { if (s.votes > max) max = s.votes; });
    q('[data-mpn-spk-rows]').innerHTML = speakers.map(function (s, i) {
      return '<div class="mpn-tool__row"><span class="mpn-tool__name">' + esc(s.name) + '</span>' +
        (s.votes > 0 && s.votes === max ? badge('CLOSES THE NIGHT', '#2B6BFF') : '') +
        '<span style="font-size:14px;font-weight:700;color:#1D4FC4">' + s.votes + ' votes</span>' +
        '<button type="button" class="mpn-tool__pillbtn" data-i="' + i + '">+ vote</button></div>';
    }).join('');
  }
  q('[data-mpn-toast-toggle]').addEventListener('click', function () {
    if (toastTimer) {
      clearInterval(toastTimer);
      toastTimer = null;
    } else {
      if (toastLeft === 0) toastLeft = 30;
      toastTimer = setInterval(function () {
        toastLeft -= 1;
        if (toastLeft <= 0) { toastLeft = 0; clearInterval(toastTimer); toastTimer = null; }
        renderToast();
      }, 1000);
    }
    renderToast();
  });
  q('[data-mpn-toast-reset]').addEventListener('click', function () {
    if (toastTimer) { clearInterval(toastTimer); toastTimer = null; }
    toastLeft = 30;
    renderToast();
  });
  wireAdd('[data-mpn-spk-name]', '[data-mpn-spk-add]', function (n) {
    if (n) { speakers.push({ name: n, votes: 0 }); renderSpeakers(); }
  });
  q('[data-mpn-spk-rows]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-i]');
    if (!b) return;
    speakers[+b.getAttribute('data-i')].votes += 1;
    renderSpeakers();
  });

  /* ---- Secret Mullet: derangement deal, peek, catch ---- */
  var secret = [];
  var dealt = false;
  function renderSecret() {
    var alive = secret.filter(function (p) { return !p.out; });
    q('[data-mpn-sec-deal]').hidden = !(secret.length >= 3 && !dealt);
    q('[data-mpn-sec-rows]').innerHTML = secret.map(function (p, i) {
      var bits = '<div class="mpn-tool__row"><span class="mpn-tool__name">' + esc(p.name) + '</span>';
      if (p.out) bits += badge('CAUGHT', '#17102B');
      if (dealt && !p.out && alive.length === 1) bits += badge('LAST HEAD STANDING', '#22E5A2', '#17102B');
      if (p.peek && dealt && !p.out && p.target != null) {
        bits += '<span style="font-size:14px;font-weight:700;color:#0E8A5F">hunting ' + esc(secret[p.target].name) + '</span>';
      }
      if (dealt && !p.out && p.target != null && alive.length > 1) {
        bits += '<button type="button" class="mpn-tool__pillbtn" data-i="' + i + '" data-act="peek">' + (p.peek ? 'Hide' : 'Peek') + '</button>';
      }
      if (dealt && !p.out && alive.length > 1) {
        bits += '<button type="button" class="mpn-tool__pillbtn" data-i="' + i + '" data-act="caught">Caught wigless</button>';
      }
      return bits + '</div>';
    }).join('');
  }
  wireAdd('[data-mpn-sec-name]', '[data-mpn-sec-add]', function (n) {
    if (n && !dealt) { secret.push({ name: n, target: null, out: false, peek: false }); renderSecret(); }
  });
  q('[data-mpn-sec-reset]').addEventListener('click', function () { secret = []; dealt = false; renderSecret(); });
  q('[data-mpn-sec-deal]').addEventListener('click', function () {
    var n = secret.length;
    if (n < 2) return;
    var idx;
    var ok = false;
    while (!ok) {
      idx = [];
      for (var i = 0; i < n; i++) idx.push(i);
      for (var i2 = n - 1; i2 > 0; i2--) {
        var j = Math.floor(Math.random() * (i2 + 1));
        var t = idx[i2]; idx[i2] = idx[j]; idx[j] = t;
      }
      ok = idx.every(function (v, k) { return v !== k; });
    }
    secret.forEach(function (p, i3) { p.target = idx[i3]; p.out = false; p.peek = false; });
    dealt = true;
    renderSecret();
  });
  q('[data-mpn-sec-rows]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var i = +b.getAttribute('data-i');
    if (b.getAttribute('data-act') === 'peek') {
      secret[i].peek = !secret[i].peek;
    } else {
      secret.forEach(function (p) { p.peek = false; });
      var hunter = -1;
      secret.forEach(function (p, k) { if (!p.out && p.target === i) hunter = k; });
      if (hunter >= 0) secret[hunter].target = secret[i].target;
      secret[i].out = true;
      secret[i].target = null;
    }
    renderSecret();
  });

  /* ---- Freeze: god-mode toggle + loss tally ---- */
  var freezeOn = false;
  var frz = [];
  function renderFreeze() {
    var panel = q('[data-mpn-tool="freeze"]');
    var big = q('[data-mpn-frz-big]');
    panel.style.background = freezeOn ? '#FFE3F0' : '#DFFBF0';
    q('[data-mpn-frz-k]').style.color = freezeOn ? '#D6216B' : '#0E8A5F';
    big.style.background = freezeOn ? '#FF3D8A' : '#22E5A2';
    big.style.color = freezeOn ? '#fff' : '#17102B';
    big.textContent = freezeOn ? 'FREEZE. Nobody moves.' : 'Music plays. Dance.';
    q('[data-mpn-frz-rows]').innerHTML = frz.map(function (p, i) {
      return '<div class="mpn-tool__row"><span class="mpn-tool__name">' + esc(p.name) + '</span>' +
        '<span style="font-size:14px;font-weight:700;color:#D6216B">' + p.losses + (p.losses === 1 ? ' loss' : ' losses') + '</span>' +
        '<button type="button" class="mpn-tool__pillbtn" data-i="' + i + '">Moved. + loss</button></div>';
    }).join('');
  }
  q('[data-mpn-frz-big]').addEventListener('click', function () { freezeOn = !freezeOn; renderFreeze(); });
  q('[data-mpn-frz-reset]').addEventListener('click', function () { frz = []; renderFreeze(); });
  wireAdd('[data-mpn-frz-name]', '[data-mpn-frz-add]', function (n) {
    if (n) { frz.push({ name: n, losses: 0 }); renderFreeze(); }
  });
  q('[data-mpn-frz-rows]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-i]');
    if (!b) return;
    frz[+b.getAttribute('data-i')].losses += 1;
    renderFreeze();
  });

  /* ---- The Documentary: shot list ---- */
  var DOC_LABELS = [
    'A stranger wearing one of your mullets',
    'A mullet in a family portrait',
    'A mullet ordering food, dead serious',
    'The whole crew in one frame',
    'One shot good enough to be a profile picture'
  ];
  var docChecks = [false, false, false, false, false];
  function renderDoc() {
    var count = docChecks.filter(Boolean).length;
    q('[data-mpn-doc-count]').textContent = count + ' OF 5';
    q('[data-mpn-doc-done]').hidden = count !== 5;
    q('[data-mpn-doc-rows]').innerHTML = DOC_LABELS.map(function (label, i) {
      var on = docChecks[i];
      return '<button type="button" class="mpn-doc__item' + (on ? ' is-done' : '') + '" data-i="' + i + '" aria-pressed="' + on + '">' +
        '<span class="mpn-doc__dot">' + (on ? '✓' : '') + '</span>' +
        '<span class="mpn-doc__label">' + label + '</span></button>';
    }).join('');
  }
  q('[data-mpn-doc-rows]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-i]');
    if (!b) return;
    var i = +b.getAttribute('data-i');
    docChecks[i] = !docChecks[i];
    renderDoc();
  });

  renderWig(); renderBag(); renderOly(); renderToast(); renderSpeakers();
  renderSecret(); renderFreeze(); renderDoc();
})();
